import { useMutation } from '@tanstack/react-query';
import { saveConsent } from '@services/cpqService';
import type { ConsentRequest } from '@t/api.types';

interface UseConsentOptions {
  onSuccess?: (data: unknown) => void;
  onError?: (error: Error) => void;
}

export const useConsent = (sessionId: string, { onSuccess, onError }: UseConsentOptions = {}) => {
  const mutation = useMutation<unknown, Error, ConsentRequest>({
    mutationFn: (payload) => saveConsent(sessionId, payload),
    onSuccess,
    onError,
  });

  return {
    submitConsent: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  };
};
